import { render, useState, useEffect } from '@wordpress/element';
import Dashboard from './Dashboard';
import Settings from './Settings';
// import Roadmap from './Roadmap';
// import License from './License'; // Import the new component
import Icon from './Icon';

const { pro_active } = window.INSTANT_PAGE_LOAD;

const App = () => {
    // Retrieve the last active tab from localStorage or default to 'dashboard'
    const getInitialTab = () => {
        const savedTab = localStorage.getItem('activeTab');
        return savedTab && (savedTab === 'license' && !pro_active) ? 'dashboard' : savedTab || 'dashboard';
    };

    const [activeTab, setActiveTab] = useState(getInitialTab);

    useEffect(() => {
        // Save the active tab to localStorage whenever it changes
        localStorage.setItem('activeTab', activeTab);
    }, [activeTab]);

    const renderContent = () => {
        switch (activeTab) {
            case 'dashboard':
                return <Dashboard />;
            case 'settings':
                return <Settings />;
            // case 'license': // Handle the new tab
                // return <License />;
            // case 'roadmap':
                // return <Roadmap />;
            default:
                return <Dashboard />;
        }
    };

    return (
        <div className="p-4">
            <div className="flex mb-6 bg-white px-6 py-4 rounded gap-3">
                <button
                    className={`flex items-center px-6 py-3 rounded ${activeTab === 'dashboard' ? 'bg-blue-50 text-blue-500' : 'bg-white hover:bg-blue-50'}`}
                    onClick={() => setActiveTab('dashboard')}
                >
                    <Icon iconType="dashboard" />
                    Dashboard
                </button>
                <button
                    className={`flex items-center px-6 py-3 rounded ${activeTab === 'settings' ? 'bg-blue-50 text-blue-500' : 'bg-white hover:bg-blue-50'}`}
                    onClick={() => setActiveTab('settings')}
                >
                    <Icon iconType="settings" />
                    Settings
                </button>
                {/* {pro_active && ( // Conditionally render the License button
                    <button
                        className={`flex items-center px-6 py-3 rounded ${activeTab === 'license' ? 'bg-blue-50 text-blue-500' : 'bg-white hover:bg-blue-50'}`}
                        onClick={() => setActiveTab('license')}
                    >
                        <Icon iconType="license" />
                        License
                    </button>
                )} */}
                {/* <button
                    className={`flex items-center px-6 py-3 rounded ${activeTab === 'roadmap' ? 'bg-blue-50 text-blue-500' : 'bg-white hover:bg-blue-50'}`}
                    onClick={() => setActiveTab('roadmap')}
                >
                    <Icon iconType="roadmap" />
                    Roadmap
                </button> */}
            </div>
            <div>
                {renderContent()}
            </div>
        </div>
    );
};

export default App;
